import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { Button } from '@pets-ui/Button/Button'
import { Collapse } from '@pets-ui/Collapse/Collapse'
import { ArrowDownSmall, ArrowUpSmall } from '@pets-ui/icons'
import { typography } from '@pets-ui/tokens/typography.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { Children, useState } from 'react'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

const styles = stylex.create({
  button: {
    fontSize: typography.sizeCaption,
  },
  buttonEndIcon: {
    fontSize: 16,
    marginLeft: 4,
  },
})

export interface RegularGiveawayListProps {
  maxLength: number
  children: React.ReactNode
  onExpandList?: () => void
}

export const RegularGiveawayList = (props: RegularGiveawayListProps) => {
  const { maxLength, children, onExpandList } = props
  const list = Children.toArray(children)
  const visibleList = list.slice(0, maxLength)
  const collapsedList = list.slice(maxLength)
  const [isCollapsed, setIsCollapsed] = useState(true)

  const handleToggleCollapse = useCallbackEvent(() => {
    const collapseState = !isCollapsed
    if (!collapseState) {
      onExpandList?.()
    }
    setIsCollapsed(collapseState)
  })

  const shouldShowCollapse = maxLength < list.length
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })
  return (
    <VStack>
      <VStack gap={4} mb={shouldShowCollapse ? 4 : 0}>{visibleList}</VStack>
      {shouldShowCollapse && (
        <>
          <Collapse in={!isCollapsed}>
            <VStack gap={4} mb={4}>{collapsedList}</VStack>
          </Collapse>
          <Button
            xStyles={{
              root: styles.button,
              endIcon: styles.buttonEndIcon,
            }}
            variant="text"
            color="grey"
            onClick={handleToggleCollapse}
            endIcon={isCollapsed ? <ArrowDownSmall /> : <ArrowUpSmall />}
            fontSize="body"
          >
            {isCollapsed ? t('cartUi.more', { defaultValue: '更多' }) : t('cartUi.less', { defaultValue: '收合' })}
            {t('cartUi.coupons', { defaultValue: '優惠' })}
          </Button>
        </>
      )}
    </VStack>
  )
}
